/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Finish_Confirm_PlayersInputs */



/**
* | output |
* | --- |
* | "{count} player(s) will be ranked and rated" |
*
* @param {Finish_Confirm_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finish_confirm_players = /** @type {((inputs: Finish_Confirm_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finish_Confirm_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueur(s) seront classés et notés`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugador/es serán clasificados y puntuados`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogador/es serão classificados e avaliados`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatore/i saranno classificati e valutati`)
	return /** @type {LocalizedString} */ (`${i?.count} player(s) will be ranked and rated`)
});